import {BooleanFilter, MultipleChoiceFilter, DateTimeFilter} from 'Components/Filters';

import {translation} from 'Services/TranslationHelpers';
import {translationFromJson} from 'Services/TranslationHelpers2';
import {timeToTwelveHour} from 'Services/DateHelpers';

/**
 * @method getRecordValue
 * @param {object} record
 * @param {string} field_identifier
 * @param {string} field_type
 * @return {mixed}
 */
const getRecordValue = (record, field_identifier, field_type = null) => {
    let value_model = record.values.filter(o => o.field.identifier === field_identifier);

    if (!value_model || value_model.length === 0) {
        return null;
    }

    let value = value_model[0].value;

    // Guard against null/undefined values before attempting to access properties
    if (!field_type) {
        return value == null ? null : value;
    }

    if (field_type === 'date') {
        // value may be null or an object containing date_timezone
        value = value && value.date_timezone ? value.date_timezone : null;
    } else if (field_type === 'time') {
        value = value && value.time_timezone ? timeToTwelveHour(value.time_timezone) : null;
    } else if (field_type === 'boolean') {
        // Treat any truthy value as 'Yes', otherwise 'No'
        value = value ? 'Yes' : 'No';
    } else if (field_type === 'file') {
        // File values are objects with a url property; return null if missing
        value = value && value.url ? value.url : null;
    }

    return value;
}

/**
 * @method getFieldFilter
 * @return {array} fields
 * @return {array}
 */
const getFieldsFilter = (fields) => {
    let filters = [];

    let columns = Object.entries(fields).map((data, j) => {
        let new_filters = getFieldFilter(data[1]);

        filters = [...filters, ...new_filters];
    });

    return filters;
}

/**
 * @method getFieldFilter
 * @return {object} field
 * @return {array}
 */
const getFieldFilter = (field) => {
    let filters = [];

    if (field.type === 'boolean') {
        filters = [
            {
                column: field.id,
                label: translationFromJson(field.label),
                component: BooleanFilter
            }
        ];
    } else if (field.type === 'multiple_choice_single_value') {
        filters = [
            {
                column: field.id,
                label: translationFromJson(field.label),
                component: MultipleChoiceFilter,
                props: {
                    options: field.multiple_choice_values.map((value, key) => {
                        let translation_value = translation('misc', value, null, false);

                        return {
                            label: translation_value && translation_value !== '' ? translation_value : value,
                            value: value
                        };
                    })
                }
            }
        ];
    } else if (field.type === 'date' || field.type === 'time') {
        filters = [
            {
                column: field.id,
                label: translationFromJson(field.label) + ' Before',
                component: DateTimeFilter,
                props: {
                    type: field.type,
                    direction: 'before'
                }
            },
            {
                column: field.id,
                label: translationFromJson(field.label) + ' After',
                component: DateTimeFilter,
                props: {
                    type: field.type,
                    direction: 'after'
                }
            }
        ];
    }

    return filters;
}

export {
    getRecordValue,
    getFieldsFilter,
    getFieldFilter
}
